var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiSelect from '@mui/material/Select';
import { ArrowNextIcon } from '../../icons';
/**
 * Pigment [Select](https://pigment.customink.com/?path=/docs/components-select)
 */
var Select = function (props, ref) { return React.createElement(MuiSelect, __assign({ ref: ref, IconComponent: ArrowNextIcon }, props)); };
var ForwardedSelect = React.forwardRef(Select);
export default ForwardedSelect;
//# sourceMappingURL=Select.js.map